import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FAQItem } from '@/types'

/**
 * FAQ item props
 */
export interface FaqItemProps {
  /** FAQ item data */
  item: FAQItem
  /** Whether this item is expanded */
  expanded: boolean
  /** Change handler */
  onChange: () => void
}

/**
 * FaqItem Component
 * Displays a single FAQ item with accordion
 */
export const FaqItem = ({ item, expanded, onChange }: FaqItemProps) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      elevation={0}
      sx={{
        '&:before': {
          display: 'none',
        },
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 1,
        mb: 2,
        '&.Mui-expanded': {
          mb: 2,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${item.id}-content`}
        id={`${item.id}-header`}
        sx={{
          '& .MuiAccordionSummary-content': {
            my: 2,
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.125rem' },
          }}
        >
          {item.question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          pt: 0,
          pb: 3,
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            lineHeight: 1.7,
          }}
        >
          {item.answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}
